<template>
    <div>
        <DataTable
                editMode="cell"
                columnResizeMode="fit"
                dataKey="id"
                :rowClass="rowClass"
                @cell-edit-complete="onCellEditComplete"
                :value="testsNames"
                :paginator="true"
                :resizableColumns="false"
                :selection.sync="selectedItems"
                responsiveLayout="scroll"
                :loading="loading"
                :filters="filters"
                :rows="50"

                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 30, 50, 200]"
                currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
        >
            <!-- header -->

            <template #header>
                <div class="p-p-2 table-header">
                    <div class="p-m-1 p-d-inline-flex">
                        <h1 style="text-align: center">שמות מבחנים</h1>
                    </div>

                    <div class="p-d-flex">

                        <Button
                                v-tooltip.top="'מחיקה'"
                                v-if="selectedItems.length > 0"
                                icon="pi pi-trash"
                                class="p-mr-2 p-button-danger"
                                @click="isDialogDelete = true"
                        />
<!--                        <Button-->
<!--                                v-tooltip.top="'הוספה'"-->
<!--                                icon="pi pi-plus"-->
<!--                                class="p-mr-2 p-button-success"-->
<!--                                @click="isDialogAdd = true"-->
<!--                        />-->
                    </div>
                </div>
            </template>
            <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

            <!-- v-for -->
            <Column
                    headerStyle="text-align: rtl"
                    bodyStyle="text-align: right; overflow: visible"
                    v-for="col of columns"
                    :field="col.field"
                    :header="col.header"
                    :filterMatchMode="col.filterMode"
                    :filterField="col.field"
                    :filterFunction="col.filterCustom"
                    :filter="true"
                    sortable
                    :sortField="col.sortField || col.field"
            >
                <template #body="slotProps">
                    <div v-if="col.type === 'string'">
                        {{ slotProps.data[col.field] }}
                    </div>
                    <div v-if="col.type === 'subject'">
                        {{ getLessonName(slotProps.data[col.field]) }}
                    </div>
                    <div v-if="col.type === 'grade'">
                        {{ getGradeName(slotProps.data[col.field]) }}
                    </div>
                    <div v-if="col.type === 'date'">
                        {{ new Date(slotProps.data[col.field]).toLocaleDateString() }}
                    </div>
                    <div v-if="col.type === 'user'">
                        {{ getTeacherName(slotProps.data[col.field]) }}
                    </div>
                    <div v-if="col.type === 'checkbox'">
                        <checkbox
                                @input="onCellEdit($event, slotProps)"

                                v-model="slotProps.data[col.field]"
                                :binary="true"/>
                    </div>
                </template>

                <template #filter>
                    <div v-if="col.type === 'string'">
                        <InputText
                                type="text"
                                v-model="filters[col.field]"
                                class="p-column-filter"
                                :placeholder="`חפש לפי תוכן`"
                        />
                    </div>
                    <div v-if="col.type === 'date'">

                    <Calendar
                                :touchUI="true"
                                :showButtonBar="true"
                                dateFormat="dd.mm.yy"
                                selectionMode="range"
                                v-model="filters[col.field]"
                                placeholder="סנן לפי תאריך"
                        />
                    </div>
                    <div v-if="col.type === 'subject'">
                        <MultiSelect
                                filterPlaceholder=" חפש לפי נושא"
                                emptyFilterMessage=" לא נמצא שם נושא תואם"
                                :filter="true"
                                dataKey="id"
                                optionLabel="hebrewName"
                                v-model="filters[col.field]"
                                :options="subjectLesson"
                                :showClear="true"
                                placeholder="סנן לפי נושא"
                        >
                            <template #option="slotProps">
                                <span>{{ slotProps.option.hebrewName }}</span>
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.hebrewName }},
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </div>
                    <div v-if="col.type === 'user'">

                        <MultiSelect
                                filterPlaceholder=" חפש לפי שם מורה"
                                emptyFilterMessage=" לא נמצא שם מורה תואם"
                                :filter="true"
                                dataKey="id"
                                optionLabel="lastname"
                                v-model="filters[col.field]"
                                :options="teachers"
                                :showClear="true"
                                placeholder="סנן לפי מורה"
                        >
                            <template #option="slotProps">
                <span>
                  {{ slotProps.option.firstname }}
                  {{ slotProps.option.lastname }}</span
                >
                            </template>
                            <template #value="slotProps">
                                <div v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ slotProps.placeholder }}
                                </div>
                                <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.firstname }}
                    {{ a.lastname }},
                  </span>
                </span>
                            </template>
                        </MultiSelect>
                    </div>
                    <div v-if="col.type === 'grade'">

                    <MultiSelect
                            filterPlaceholder=" חפש לפי שם כיתה"
                            emptyFilterMessage=" לא נמצא שם כיתה תואם"
                            :filter="true"
                            dataKey="id"
                            optionLabel="hebrewName"
                            v-model="filters[col.field]"
                            :options="gradeOptions"
                            :showClear="true"
                            placeholder="סנן לפי כיתה"
                    >
                        <template #option="slotProps">
                            <span>{{ slotProps.option.hebrewName }}</span>
                        </template>
                        <template #value="slotProps">
                            <div v-if="!slotProps.value || slotProps.value.length === 0">
                                {{ slotProps.placeholder }}
                            </div>
                            <span v-else>
                  <span v-for="(a, index) in slotProps.value" :key="index">
                    {{ a.hebrewName }},
                  </span>
                </span>
                        </template>
                    </MultiSelect>
                    </div>
                    <div v-if="col.type === 'checkbox'">

                    <Dropdown
                            :showClear="true"
                            v-model="filters[col.field]"
                            :options="[true, false]"
                            placeholder="סנן לפי מצב"
                    >
                        <template #option="slotProps">
                            <span>{{ getEnabledLabel(slotProps.option) }}</span>
                        </template>
                        <template #value="slotProps">
                            <div v-if="!slotProps.value || slotProps.value.length === 0">
                                {{ slotProps.placeholder }}
                            </div>
                            <div v-else>{{ getEnabledLabel(slotProps.value) }},</div>
                        </template>
                    </Dropdown>
                    </div>

                </template>

                <template v-if="col.editable " #editor="slotProps">
                    <div v-if="col.type === 'string'">
                        <InputText
                                :value="slotProps.data[slotProps.column.field]"
                                @input="onCellEdit($event, slotProps)"

                        />
                    </div>
                    <div v-if="col.type === 'checkbox'">
                        <checkbox
                                @input="onCellEdit($event, slotProps)"

                                v-model="slotProps.data[slotProps.column.field]" :binary="true"></checkbox>

                    </div>
                </template>
            </Column>
            <!-- v-for -->

            <template #footer>
                סה״כ {{ testsNames ? testsNames.length : 0 }} רשומות.
            </template>
        </DataTable>
        <!--        <add-dialog-->
        <!--                :show="isDialogAdd"-->
        <!--                v-on:addItem="addItem"-->
        <!--                v-on:closeDialog="isDialogAdd = false"-->
        <!--        />-->
        <delete-dialog
                :title="'מחיקה'"
                :context="`האם תרצה להסיר  ${selectedItems.length}רשומות מהמערכת?`"
                :show="isDialogDelete"
                v-on:choice="deleteItem"
        />
    </div>
</template>

<script>
import Service from "@/service/Service";
import Vue from "vue";
import deleteDialog from "../../../dialogs/DeleteDialog.vue";

import axios from "axios";
import {getGradeFullName, getLessonFullName, getUserFullName} from "@/utils/parseObj";
import DeleteDialog from "@/dialogs/DeleteDialog";
import {mapState} from "vuex";

export default {
    components: {DeleteDialog},
    computed: {
        ...mapState(["user", "teachers", "gradeOptions", "subjectLesson"])
    },
    name: "TestNames",
    data() {
        return {
            loading: true,
            isDialogAdd: false,
            isDialogDelete: false,
            selectedItems: [],
            testsNames: [],
            filters: {},
            columns: [
                {field: "name", header: "שם", type: "string", editable: true, filterMode: "contains"},
                {field: "subject", header: "נושא", type: "subject", filterMode: "custom", filterCustom: this.filterObjectById, sortField:(data) => this.getLessonName(data.subject) },
                {field: "grade", header: "כיתה", type: "grade", filterMode: "custom", filterCustom: this.filterObjectById, sortField:(data) => this.getGradeName(data.grade)},
                {field: "date", header: "תאריך", type: "date", filterMode: "custom", filterCustom: this.filterDate},
                {field: "user", header: "מורה", type: "user", editable: true, filterMode: "custom", filterCustom: this.filterObjectById, sortField:(data) => this.getTeacherName(data.user)},
                {field: "toReport", header: "פעיל", type: "checkbox", editable: true, filterMode: "equals"},
            ],

        }
    },
    async created() {
        try {
            const service = new Service()
            const {data} = await service.gerTestsNames()
            this.testsNames = data.testNames
            this.loading = false
        } catch (e) {

        }

    },
    methods: {
        filterDate(value, filter) {
            if (
                filter === undefined ||
                filter === null ||
                (typeof filter === "string" && filter.trim() === "")
            ) {
                return true;
            }

            if (value === undefined || value === null) {
                return false;
            }

            if (filter[1] !== null) {
                return value >= Date.parse(filter[0]) && value <= Date.parse(filter[1]);
            } else if (filter[1] === null) {
                const a = new Date(value);
                a.setDate(a.getDate() - 1);
                return a.getTime() === filter[0].getTime();
            }
            return true;
        },
        getEnabledLabel(boolean) {
            switch (boolean) {
                case false:
                    return "לא פעיל";
                case true:
                    return "פעיל";
            }
        },
        filterObjectById(value, filter) {
            if (
                filter.length === 0 ||
                filter === undefined ||
                filter === null ||
                (typeof filter === "string" && filter.trim() === "")
            ) {
                console.log("true 1")

                return true;
            }

            if (value === undefined || value === null) {
                console.log("false 1")

                return false;
            }
            let isExist = false;
            filter.forEach((filter) => {
                if (filter.id === value) {
                    isExist = true;
                }
            });
            return isExist;
        },
        async deleteItem(choice) {
            this.isDialogDelete = false;
            if (choice) {
                this.loading = true;
                const itemsIds = [];
                const selscteds = this.selectedItems;
                this.selectedItems.forEach((item) => {
                    itemsIds.push(item.id);
                });

                try {
                    await axios.delete(`/test/delete-many-names`,
                        {
                            data: itemsIds
                        }
                    )
                    this.loading = false;

                    this.openNotification(
                        "success",
                        `מעולה`,
                        ` רשומות נמחקו${itemsIds.length} `
                    );

                    selscteds.forEach((selected) => {
                        this.testsNames = this.testsNames.filter((item) => item.id !== selected.id);
                    });
                } catch (e) {
                    this.loading = false;
                    this.openNotification(
                        "danger",
                        `אופס`,
                        `לא הצלחנו למחוק את הרשומות מהמערכת`
                    );
                    this.testsNames.push(...this.selectedItems);
                    this.selectedItems = [];
                }


                this.isDialogDelete = false;
            }
            this.selectedItems = [];
        },
        rowClass(data) {
            return data.enabled === false ? "row-unenabled" : null;
        },
        getLessonName(id) {
            return getLessonFullName(id)
        },
        getGradeName(id) {
            return getGradeFullName(id)
        },
        getTeacherName(id) {
            return getUserFullName(id)
        },
        updateAdminSystemDate(event) {
            if (event[1]) {
                const startDate = event[0].getTime()
                const endDate = event[1].getTime()
                Vue.ls.set('startDateDefaultRequest', startDate)
                Vue.ls.set('endDateDefaultRequest', endDate)
                axios.defaults.headers.common['startDate'] = startDate
                axios.defaults.headers.common['endDate'] = endDate
            }
        },
        async onCellEditComplete(event) {
            const index = this.testsNames.findIndex(
                (item) => item.id === this.itemAfterEditing.id
            );
            this.testsNames[index] = this.itemAfterEditing;


            const clone = JSON.parse(JSON.stringify(this.itemAfterEditing));
            if (typeof clone.user === 'object') clone.user = clone.user.id

            Vue.set(this.testsNames, index, clone);

            console.log(this.itemAfterEditing)
            // clone.grade = this.itemAfterEditing.grade.id;
            // clone.subject = this.itemAfterEditing.subject.id;
            // clone.time = this.itemAfterEditing.time.id;
            // clone.date = this.itemAfterEditing.date;
            //
            // // clone.date += (1000 * 60 * 60 * 24);
            // clone.user = this.itemAfterEditing.user.id;
            try {
                await axios.put(`/test/update-name`, clone)


            } catch (e) {
                console.log(e)
                Vue.set(this.testsNames, index, this.itemBeforeEditing);
                this.openNotification(
                    "danger",
                    `אופס`,
                    `קרתה תקלה בעדכון הנתונים במערכת`
                );
            }
        },
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
    }
}
</script>

<style scoped>

</style>